<template>
  <div
    class="relative inline w-6 h-6 cursor-pointer"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
    @click="$emit('click')"
  >
    <router-link :class="baseClass" :to="linkTo" v-if="buttonType === 'link'">
      <slot> </slot>
    </router-link>
    <button
      @click="$emit('click')"
      type="button"
      :class="baseClass"
      v-if="buttonType === 'button'"
    >
      <slot></slot>
    </button>
    <div
      v-if="showTooltip && tooltip"
      class="absolute inset-0 z-10 inline-block w-full pl-2 -mt-10 whitespace-no-wrap"
    >
      <span class="px-2 py-1 rounded shadow bg-primary-dark">
        {{ tooltip }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tooltip: {
      type: String,
      default: null
    },
    delay: {
      type: Number,
      default: 500
    },
    buttonType: {
      type: String,
      default: "button"
    },
    linkTo: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      baseClass:
        "bg-transparent border-none cursor-pointer text-highlight no-underline p-0",
      showTooltip: false,
      isMouseOver: false
    };
  },
  methods: {
    mouseEnter() {
      this.isMouseOver = true;

      setTimeout(() => {
        this.showTooltip = this.isMouseOver;
      }, this.delay);
    },
    mouseLeave() {
      this.isMouseOver = false;

      setTimeout(() => {
        this.showTooltip = false;
      }, this.delay);
    }
  }
};
</script>

<style lang="postcss" scoped></style>
